// extracted by mini-css-extract-plugin
module.exports = {"container":"doctorLoadSpinner_container__ssIzK","spinner":"doctorLoadSpinner_spinner__1U5Qe"};